import { memo } from 'react';

import { usePrivateAssetTransformationTasksSync } from '~/components/AssetTransformationTasks/usePrivateAssetTransformationTasksSync';

export const PrivateAssetTransformationTasksListener = memo(() => {
  usePrivateAssetTransformationTasksSync();

  return null;
});

PrivateAssetTransformationTasksListener.displayName = 'PrivateAssetTransformationTasksListener';
